import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { FunctionService, LanguageService } from 'vhobjects-service/src/services';
import { MatDialog } from '@angular/material/dialog';
import { ChooseImageComponent, ManageLibraryComponent } from 'vhobjects-service';
import { ThemeService } from 'vhobjects-service/src/services';

@Component({
  selector: 'app-sharing-social-config',
  templateUrl: './sharing-social-config.component.html',
  styleUrls: ['./sharing-social-config.component.scss'],
})
export class AtwSharingSocialConfig implements OnInit {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config: string; // xác định trang đang ở page hay preview
  @Input() device: any; // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;
  @Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung',
      index: 0,
    },
  ];
  socialItemSelected = 'facebook';
  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};
  dataAfterChange: any = {};
  isPushImgToServerLoading = false;
  isShowPushImgToServerPopup = false;
  dragging = false;
  previewUploadUrl = '';
  id_subproject: any;
  subproject: any;
  resolution: any;
  unSelected: any;
  compressWidth = 100;
  compressHeight = 100;
  path = '';
  compress_type = 'compress-frame';
  image_source = 'device';
  customize = [];
  socialItem:any=[
    {
      "name": "Facebook",
      "var": "facebook",
      "image": "https://ericduong107.github.io/assets/test/facebook.png",
      "toggle": "is_facebook"
    },
    {
      "name": "Twitter",
      "var": "twitter",
      "image": "https://ericduong107.github.io/assets/test/twitter.png",
      "toggle": "is_twitter"
    },
    {
      "name": "Linkedin",
      "var": "linkedin",
      "image": "https://ericduong107.github.io/assets/test/linkedin.png",
      "toggle": "is_linkedin"
    },
    {
      "name": "WhatsApp",
      "var": "whatsapp",
      "image": "https://ericduong107.github.io/assets/test/whatsapp.webp",
      "toggle": "is_whatsapp"
    },
    {
      "name": "Zalo",
      "var": "zalo",
      "image": "https://ericduong107.github.io/assets/test/zalo.webp",
      "toggle": "is_zalo"
    }
  ];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    private functionService: FunctionService,
    private languageService: LanguageService,
    private vhImage: VhImage,
    private matDialog: MatDialog,
    public themeService: ThemeService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/sharing-social.json'),
      this.http.get('assets/background-colors/background-colors.json'),
    ]).subscribe(([fonts, effects]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
    });

    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(this.id_subproject);
    this.resolution = this.subproject.resolution;
  }

  ngOnChanges(): void {
    this.initDataIfNull();
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  handleShowHideTextImage(obj: 'image' | 'text', event) {
    const other = obj === 'image' ? 'text' : 'image';
  
    // Cập nhật giá trị mới
    this.config[`${obj}_enable`] = event;

    // Nếu cả hai đều bị tắt, buộc phải bật cái còn lại
    if (!this.config[`${obj}_enable`] && !this.config[`${other}_enable`]) {
      this.config[`${other}_enable`] = true;
    }

    this.updateConfig();
  }

  /** UPLOAD IMAGE */
  openUpload() {
    var inputVal = document.querySelector('#uploadBackgroundImage') as HTMLElement;
    inputVal.click();
  }
  onUpload(e) {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      this.vhImage
        .getImageFromDesktop(
          file,
          this.path || 'images/design/objects',
          this.staticdata.image[this.socialItemSelected] || null,
          2000000
        )
        .then(
          (rsp: any) => {
            if (rsp.vcode === 0) {
              this.staticdata.image[this.socialItemSelected] = rsp.data;
              this.updateStaticData();
              this.functionService.createMessage('success', 'tai_anh_thanh_cong');
            } else {
              this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${rsp.msg}`);
            }
          },
          (error) => {
            console.log('image upload failed', error);
          }
        );
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_keo_tep_hinh_anh_hop_le');
        return;
      }
    }
  }

  /**
   * Hàm xử lý khi người dùng kéo và thả (drop) một tệp vào vùng upload.
   * @param event file được kéo vào
   */
  onFileDropped_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = false;
    const file = event.dataTransfer?.files[0];

    if (file && file.type.startsWith('image/')) {
      // Hiển thị preview
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUploadUrl = reader.result as string;
      };
      reader.readAsDataURL(file);

      // Xử lý tệp hình ảnh
      this.vhImage
        .getImageFromDesktop(
          file,
          this.path || 'images/design/objects',
          this.previewUploadUrl,
          2000000
        )
        .then(
          (rsp: any) => {
            if (rsp.vcode === 0) {
              this.staticdata.image[this.socialItemSelected] = rsp.data;
              this.updateStaticData();
              this.functionService.createMessage('success', 'tai_anh_thanh_cong');
            } else {
              this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${rsp.msg}`);
            }
          },
          (error) => {
            console.log('image upload failed', error);
          }
        );
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_keo_tep_hinh_anh_hop_le');
        return;
      }
    }
  }

  /**
   * Lấy hình ảnh từ url đẩy lên server với kích thước hình thay đổi
   */
  handleOkConfirm() {
    this.isPushImgToServerLoading = true;

    let resolution = {};
    switch (this.compress_type) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[this.device + '_width'],
          height: 0,
        };
        break;
      case 'compress-frame':
        resolution = {
          width: this.class['social-item__content--image-wrapper'].width,
          height: this.class['social-item__content--image-wrapper'].height,
        };
        break;
      case 'custom':
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight,
        };
        this.compress_type = 'compress-frame';
        break;
    }

    if (this.staticdata.image[this.socialItemSelected]?.includes(this.id_subproject)) {
      this.functionService.createMessage('warning', 'anh_nay_da_co_tren_server');
      this.isPushImgToServerLoading = false;
      this.isShowPushImgToServerPopup = false;
      return;
    }

    this.vhImage
      .getImageFromURL_Autoweb(
        this.staticdata.image[this.socialItemSelected],
        this.path || 'images/design/objects',
        {
          compress_type: this.compress_type,
          resolution: resolution,
        }
      )
      .then((rsp: any) => {
        if (rsp.vcode == 0) {
          this.staticdata.image[this.socialItemSelected] = rsp.data;
          this.updateStaticData();
          this.functionService.createMessage('success', 'tai_anh_thanh_cong'); 
        } else {
          this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${rsp.msg}`);
        }
      })
      .catch((error) => {
        if (error.message && error.message.includes('413')) {
          this.functionService.createMessage('error', 'file_anh_qua_lon_vui_chon_file_anh_co_dung_luong_nho_hon_1mb');
        } else {
          this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')} 2: ${error.message}`);
        }
      });
    this.isPushImgToServerLoading = false;
    this.isShowPushImgToServerPopup = false;
  }

  /**
   * Hành động khi người dùng kéo file qua vùng upload (chưa thả).
   * @param event 
   */
  onDragOver_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = true;
  }

  /**
   * Hành động khi người dùng rời con trỏ khỏi vùng upload mà chưa thả.
   */
  onDragLeave_upload() {
    this.dragging = false;
  }

  /**
   * Mở thư viện để chọn ảnh
   */
  openLibrary() {
    const dialogRef = this.matDialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path || '/images',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(({ name, href, path }) => {
      this.staticdata.image[this.socialItemSelected] = href;
      this.updateStaticData();
      this.path = path;
    });
  }

  /**
   * Hàm mở ra hộp thoại chọn hình ảnh miễn phí
   */
  openImageFree() {
    const dialogRef = this.matDialog.open(ChooseImageComponent, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.staticdata.image[this.socialItemSelected] = result;
        this.updateStaticData();
      }
    });
  }

  /**
   * Lấy ra tên file và đuôi file
   * @param url Đường dẫn ảnh
   * @example const { fileName, fileExtension } = getFileInfo("https://115.78.228.208:20350/autowebapp/67c1b593b1344364462b082b/images/design/objects/3-1-768x768%20(3).png");
   */
  getFileInfo(url: string) {
    const decodedUrl = decodeURIComponent(url);
    const parts = decodedUrl.split('/');
  
    // Lấy tên file (phần cuối)
    const fullFileName = parts.pop() || '';
    const dotIndex = fullFileName.lastIndexOf('.');
  
    // Tìm và lấy phần giữa (ví dụ: "images/design/objects")
    const indexImages = parts.indexOf('images');
    const folderPath =
      indexImages !== -1 ? parts.slice(indexImages).join('/') : '';
  
    return {
      fullFileName, // ví dụ: "3-1-768x768 (3).png"
      fileName: fullFileName.substring(0, dotIndex), // "3-1-768x768 (3)"
      fileExtension: fullFileName.substring(dotIndex + 1), // "png"
      folderPath, // "images/design/objects"
    };
  }

  /**
   * Sao chép đường dẫn hình ảnh vào bộ nhớ tạm
   */
  copyLinkImg(text?: string) {
    if (!text) return;
    if (isPlatformBrowser(this.platformId)) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.functionService.createMessage('success', 'da_sao_chep_vao_bo_nho_tam', 2000);
        })
        .catch(err => {
          this.functionService.createMessage('error', 'loi_khi_sao_chep', 2000);
          console.error('❌ Lỗi khi copy:', err);
        });
    }
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    return this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
        staticdata: this.staticdata,
      })
      .then((bool: any) => {});
  }

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {});
  }

  /**
   * Hàm update config
   */
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {});
  }

  /**
   * Hàm update object vào database.
   */
  updateStaticData() {
    return this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        staticdata: this.staticdata,
      })
      .then((bool: any) => {});
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
  };

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['sharing-social']['width'] = event.width + 'px';
    if (event.height) this.class['sharing-social']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0])
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  private initDataIfNull() {
    this.class['sharing-social']['background-color'] ??= 'transparent';
    this.config['animation-selected'] ??= {};
    this.config['animation-selected'].id ??= "000000";
    this.config.image_enable ??= false;
    if (!this.class['social-item']?.['display']) {
      this.class['social-item'] = {
        ...this.class['social-item'],
        "flex": "1",
        "font-weight": "500",
        "cursor": "pointer",
        "flex-direction": "row",
        "color": "#ffffff", 
        "display": "flex",
        "background-color": "#478ac9",
        "border-bottom-width": "0px",
        "justify-content": "center",
        "border-style": "solid",
        "border-top-left-radius": "0px",
        "gap": "2px",
        "border-bottom-left-radius": "0px",
        "align-items": "center",
        "box-shadow": "none",
        "border-right-width": "0px",
        "border-color": "black",
        "border-left-width": "0px",
        "border-top-right-radius": "0px",
        "border-bottom-right-radius": "0px",
        "border-top-width": "0px"
      };
    }
    this.class['social-item__content--image-wrapper'] ??= {
      "width": "30px",
      "height": "30px"
    };
    this.class['social-item__content--image'] ??= {
      "width": "100%",
      "height": "100%",
      "object-fit": "fill",
      "object-position": "center center"
    };
    this.class['social-item__content'] ??= {
      "white-space": "pre-wrap",
      "overflow": "hidden",
      "letter-spacing": "1px",
      "font-style": "normal",
      "line-height": "1",
      "background-color": "transparent",
      "text-align": "center",
      "text-decoration": "none",
      "font-size": "16px",
      "font-family": "'Times New Roman',Arial",
      "word-break": "break-word",
      "text-transform": "uppercase",
      "z-index": "1"
    };
    this.staticdata.image ??= {};
    this.staticdata.image.facebook ??= "https://ericduong107.github.io/assets/test/facebook.png";
    this.staticdata.image.twitter ??= "https://ericduong107.github.io/assets/test/twitter.png";
    this.staticdata.image.linkedin ??= "https://ericduong107.github.io/assets/test/linkedin.png";
    this.staticdata.image.whatsapp ??= "https://ericduong107.github.io/assets/test/whatsapp.webp";
    this.staticdata.image.zalo ??= "https://ericduong107.github.io/assets/test/zalo.webp";
    this.functionService.devices.forEach(d => {
      this.staticdata[d.value + '_animation_type'] ??= 'none';
      this.staticdata[d.value + '_animation'] ??= {};
    });
  }
}
